/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import './index.scss'

class AddTextModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newTexts: [],
      text: '',
      textArray: "",
      justification: '',
      errors: [],
      isArrayType: false,
      step: 0
    }
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.display && this.props.display) {
      this.setState({
        justification: '',
        errors: []
      })
    }
  }

  addText = (add) => {
    const { t } = this.props
    const { text, newTexts, errors } = this.state
    let errorAlt = errors
    if (!text) {
      errorAlt = { ...errors, 'text': `${t('Texto nuevo')} ${t('es requerido')}`}
      return  this.setState({errors: errorAlt})
    }

    const addNewText = newTexts
    addNewText.push(text)
    this.setState({
      text: '',
      newTexts: addNewText
    })
  }

  changeTextAr = (e) => {

    this.setState({textArray: e.target.value}, this.validateFieldsOnchange('textArray', e.target.value))
  }

  onChangeArrayType = () => {
    const { isArrayType } = this.state
    this.setState({isArrayType: !isArrayType})
  }

  validateCancelBtn = () => {
    const { step } = this.state
    const { onHidden } = this.props
    if (step === 0 ) return onHidden()
    else if (step === 1 ) return this.setState({step: 0})
  }

  onSubmit = async () => {
    const { onContinueAction, onHidden } = this.props
    const { justification, step, newTexts, isArrayType, textArray } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    if (step === 0) {
      if (isArrayType) {
        const formatTextArray = JSON.parse(textArray)
        this.setState({newTexts: formatTextArray})
      }
      return this.setState({step: 1})
    } else if (step === 1) {
      onContinueAction({justification, newTexts})
      return onHidden()
    }
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t, label } = this.props
    const { justification, newTexts, step, textArray, isArrayType } = this.state
    let errors = {}
    if (step === 0 ) {
      if (isArrayType) {
        if (!textArray)errors = { ...errors, 'textArray': `${t('Formato en Array [String]')} ${t('es requerido')}`}
        else  {
          try {
            let formatTextArray = JSON.parse(textArray)
          } catch (error) {
            errors = { ...errors, 'textArray': `${t('Formato de texto no valido')}`}
          }
        }
      } else if (!newTexts.length) errors = { ...errors, 'text': `${t('Texto nuevo')} ${t('es requerido')}`}

    } else if (step === 1) {
      if (!justification) errors = { ...errors, 'justification': `${t( label || 'Justificación del cambio')} ${t('es requerido')}`}
    }
    this.setState({errors})
    return errors
  }

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );

  formatData = () => {
    const { newTexts } = this.state
    if (!newTexts.length) return []
    return newTexts.map(item => ({text: item}))
  }

  deleteText = (data) => {
    const { newTexts } = this.state
    console.log('data', data)
    const filterNexText = newTexts.filter(text => text !== data?.text) || []
    this.setState({
      newTexts: filterNexText
    })
  }

  templateText = (node, detail) => (
    <div className='p-d-flex p-jc-between'>
    <p>{node.text}</p>
      <p>
        <Button
          type="button"
          icon="pi pi-trash"
          className="p-button-text"
          style={{ marginRight: '.5em' }}
          onClick={() => this.deleteText(node)}
        />
      </p>
    </div>);
  
  render () {
    const { t, title, onHidden, label } = this.props
    const { newTexts, text, step, isArrayType, textArray } = this.state

    const childrenInitStep = (
      <div className="p-mt-2 p-fluid">

        <div className='p-col p-text-right'>
          <Button
            icon={isArrayType ? "pi pi-table": "pi pi-paperclip"}
            className="p-button-rounded p-button-secondary"
            aria-label="Bookmark"
            onClick={this.onChangeArrayType}
            tooltip={isArrayType ? "Agrear texto por texto": t('Agregar en formato Array[String]')}
          />
        </div>

        { isArrayType  ? (
          <>
            <div className="p-col p-mb-2">
              <p className="">{t('Agrega todos los textos que deseés. El formato que tienes que insertar es un Array[String]')} 
              <Button
                icon="pi pi-info-circle"
                className="p-button-text p-button-plain"
                aria-label="Bookmark"
                tooltip='["Lorem Ipsu", "is simply dummy text"]'
                tooltipOptions={{position: 'top'}}
              />
              {/* <Tooltip target=".customClassName">
                  // Content
              </Tooltip> */}
              </p>
            </div>
            <div className="col-12 md:col-4 ">
              <InputTextarea name="textArray" value={textArray} onChange={this.changeTextAr} rows={5} cols={30} />
              {this.getFormErrorMessage(`textArray`)}
            </div>
          </>
        ) : (
          <>
          <div className="p-col">
            <p className="">{t('Agrega todos los textos que deseés. Cada texto se enlistara en la tabla de abajo')}</p>
          </div>
          <div className="col-12 md:col-4 ">
            <label className="">{t('Texto nuevo')}</label>
            <div className="p-inputgroup p-mt-2">
              <InputText
                name='text'
                value={text}
                onChange={(e) => this.setState({ text: e.target.value }, this.validateFieldsOnchange('text', e.target.value))}
                onKeyDown={(e) => {
                      if (e.key === "Enter") this.addText()
                    }}
                />
              <Button
                icon="pi pi-external-link"
                type="button"
                className="p-button-success"
                onClick={this.addText}
              />
            </div>
            {this.getFormErrorMessage(`text`)}
          </div>
          <div className='p-col p-mt-2'>
          { this.formatData().length ? (
            <div className='p-d-flex p-flex-column p-ai-center'>
              <p>Textos agregados ({this.formatData().length})</p>
              <DataTable value={this.formatData()} stripedRows className='p-col-10 table-new-text'>
                <Column field="text" body={this.templateText}/>
              </DataTable>
            </div>

            ) : (
              <div className="p-col-12 not-information">
                {t('Agrega textos nuevos')}
              </div>
          )}
          <small className="">*{t('Recuerda que si un texto nuevo ya se encuentra previamente agregado. Este no será añadido.')}</small>

          </div>

          </>
        )}

        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => this.validateCancelBtn()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button> 
            <button className="p-button p-component" type="button" onClick={this.onSubmit}>
              <span className="p-button-label p-c">{t('Continuar')}</span>
            </button>
          </div>
        </div>
      </div>
    )
    const childrenConfirmStep = (
      <div className="p-mt-2 p-fluid">
        <div className="p-col">
          <label className="">{t('Estos son los texto que vas a agregar al diccionario, ¿Estas seguro ?. Por ultimo agrega la justificación del cambio')}</label>
        </div>
        <div className='p-col p-d-flex p-jc-center '>
          <DataTable value={this.formatData()} stripedRows className='p-col-10 table-new-tex-confirm'>
            <Column field="text"/>
          </DataTable>
        </div>
        <div className='p-col p-text-right'>
          <strong>{t('Total')} ({this.formatData().length}) </strong>
        </div>
        <div className='p-col'>
          <label className="p-mb-2">{label || t('Justificación del cambio')}</label>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            rows={5}
            cols={30}
            className={classNames('p-mt-2',{
              'p-invalid': this.isFormFieldValid(`justification`),
            })}
          />
          {this.getFormErrorMessage(`justification`)}
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => this.validateCancelBtn()}>
              <span className="p-button-label p-c">{t('Volver')}</span>
            </button> 
            <button className="p-button p-component" type="button" onClick={this.onSubmit}>
              <span className="p-button-label p-c">{t('Agregar')}</span>
            </button>
          </div>
        </div>
      </div>
    )

    const validateStepRender = () => {
      if (step === 0 ) return childrenInitStep
      else if (step === 1 ) return childrenConfirmStep
    }

    return (
      <Dialog
        header={title || t('Agregar textos nuevos')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {validateStepRender()}
      </Dialog>
    )
  }
}

export default withTranslation()(AddTextModal)